namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoMbRow {
        Id?: number;
        PromoId?: string;
        MbType?: string;
    }

    export namespace PsPromoMbRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoMb';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoId = "PromoId",
            MbType = "MbType"
        }
    }
}
